<template lang="pug">
.container-nav
  nav
    .pagina DevPortifolio
    ul
      li(v-for="item in navItems" :key="item.to")
        router-link(
          :to="item.to"
          class="link"
          :class="{ active: isActive(item.to) }"
        )
          LucideIcon(:name="item.icon" :size="16")
          | {{ item.label }}
    ButtonPadrao(v-if="!isMobile") Download CV
</template>

<script>
import ButtonPadrao from '@/components/ui/ButtonPadrao.vue'

export default {
  components: {
    ButtonPadrao
  },
  data() {
    return {
      navItems: [
        { label: 'Perfil', to: '/espaco-nexa/perfil', icon: 'Home' },
        { label: 'Projetos', to: '/espaco-nexa/projetos', icon: 'FolderKanban' },
        { label: 'Contato', to: '/espaco-nexa/contato', icon: 'Mail' }
      ],
      isMobile: false
    }
  },
  mounted() {
    this.checkMobile();
    window.addEventListener('resize', this.checkMobile);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkMobile);
  },
  methods: {
    isActive(path) {
      return this.$route.path === path
    },
    checkMobile() {
      this.isMobile = window.innerWidth <= 600;
    }
  }
}
</script>

<style lang="scss">
.container-nav {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 65px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: $corFundoPadraoDashboard;
  color: $corBranco;
  z-index: 1;
  border-bottom: 1px solid $borderColor;
    
    nav {
    max-width: 1360px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 30px;
    box-sizing: border-box;

    .pagina {
      font-size: 20px;
      font-weight: bold;
      margin-right: 20px;
      color: $corVerdeClaro;
    }

    ul {
      list-style: none;
      display: flex;
      gap: 10px;
      margin: 0;
      padding: 0;

      li {
        a {
          display: flex;
          align-items: center;
          justify-content: center;
          height: 36px;
          padding: 0 16px;
          border: 1px solid #3d3d3d;
          background-color: #000;
          color: #fff;
          border-radius: 6px;
          text-decoration: none;
          font-size: 14px;
          transition: all 0.3s ease;

          svg {
            margin-right: 15px;
          }
        
          &:hover {
            background-color: #3d3d3d;
            color: $corVerdeClaro;
            border-color: $corVerdeClaro;
          }

          &.active {
            background-color: $corVerdeClaro;
            color: #000;
            border-color: $corVerdeClaro;

            &:hover {
              background-color: rgba(183, 255, 0, 0.9);
            }
          }
        }
      }
    }
  }

  @media screen and (max-width: 600px) {
    position: fixed;
    top: auto;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 60px;
    justify-content: center;
    border-bottom: none;
    border-top: 1px solid $borderColor;

    nav {
      padding: 0 10px;
      justify-content: center;

      .pagina,
      .ButtonPadrao,
      .pagina {
        display: none !important;
      }

      ul {
        width: 100%;
        justify-content: center;

        li {
          a {
            font-size: 0;
            height: 36px;
            padding: 0 12px;

            svg {
              margin-right: 0 !important;
            }
          }
        }
      }
    }
  }
}
</style>